



















import { Vue, Component, Prop } from "vue-property-decorator";
import { EventBus } from '@/utils/eventBus';
const keys = {
  body: "page-body",
  attr: "data-scroll-top",
};
@Component({
  name: "pageFrame",
})
export default class extends Vue {
  @Prop()
  headStyle?: String;

  @Prop()
  bodyStyle?: String;

  @Prop()
  footStyle?: String;

  //data

  activated() {
    var elBody = this.$refs[keys.body] as any;
    let scrollTop = elBody.getAttribute(keys.attr);
    elBody.scrollTop = scrollTop || 0;
  }

  deactivated() {
    var elBody = this.$refs[keys.body] as any;
    elBody.setAttribute(keys.attr, elBody.scrollTop);
  }

  // 添加滚动事件处理方法
  handleScroll(event: Event) {
    const target = event.target as HTMLElement;
    const scrollInfo = {
      scrollTop: target.scrollTop,
      scrollHeight: target.scrollHeight,
      clientHeight: target.clientHeight,
      isBottom: target.scrollHeight - target.scrollTop - target.clientHeight < 1
    };
    // 通过事件总线广播滚动事件
    EventBus.$emit('page-scroll', scrollInfo);
  }
}
